import { InboxNotiDto } from '@diritto/common/notification/dtos/inbox-noti.dto';
import { Color } from '@diritto/common/style/color';
import { convertToDotString, convertToRelativeString } from '@diritto/common/utils/date';
import * as Styled from 'app-components/inbox/items/styles';
import { BlockIcon } from 'icons/BlockIcon';
import { Divider } from 'ui-components/common/Divider';

interface EmptyContentInboxNotiItemProps {
  inboxNoti: InboxNotiDto;
}

export const EmptyContentInboxNotiItem = ({ inboxNoti }: EmptyContentInboxNotiItemProps) => (
  <Styled.Container disabled>
    <Styled.LeftCoverSection>
      <div className="flex h-full w-full items-center justify-center rounded bg-zinc-500/50">
        <BlockIcon color={Color.Gray100} size={40} opacity={0.5} />
      </div>
    </Styled.LeftCoverSection>

    <Styled.EmptyRightSection>
      <Styled.SanitizeHTMLTitle
        opacity={0.3}
        html={`${inboxNoti.title}<span class="inbox-title-date" title="${convertToDotString(
          inboxNoti.sentAt,
        )}">${convertToRelativeString(inboxNoti.sentAt)}</span>`}
        options={{
          allowedTags: ['b', 'span'],
          allowedClasses: {
            span: ['inbox-title-date'],
          },
          allowedAttributes: { span: ['title'] },
        }}
      />
    </Styled.EmptyRightSection>
    <Divider color={Color.Gray200} />
  </Styled.Container>
);
